import React from "react";
import { connect } from "react-redux";

import SvgIcon from "@mui/material/SvgIcon";

import COLOR_THEMES, {COLORS} from "../../../../../colorThemes";
import {GroheFilterIcon} from "../../../../common/icons";

const GroheSvgFilterIcon = (props) => {

  const {filtersOpened, activeTheme} = props;

  return (
    <SvgIcon>
      <GroheFilterIcon color={filtersOpened ? COLORS.white : COLOR_THEMES[activeTheme].primary}/>
    </SvgIcon>
  )
};

const mapStateToProps = (store) => {
  const {activeTheme} = store.serverState;
  const {filtersOpened} = store.groheState;
  return {
    activeTheme,
    filtersOpened,
  };
};

export default connect(mapStateToProps)(GroheSvgFilterIcon)
